import React, { useState } from "react";
import DetailsTable from "./DetailsTable";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import {
  deleteProductItem,
  sendProductShipping,
} from "../../../../redux/reducer/productReducer";
import { submitItemsToShipment } from "../../../../redux/reducer/cartReducer";
import LoadingSpinner from "../../../animation/LoadingSpinner";

const PackedProduct = ({
  data,
  cartID,
  setEditingProducts,
  refreshData,
  loading,
}) => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [link, setLink] = useState("");
  const [numberOfTracking, setNumberOfTracking] = useState("");

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const headers = [
    "ID",
    "Prod. No",
    "Image",
    "Name",
    "Info",
    "Size",
    "Price Pro",
    "Fees",
    "Link",
    "Count",
    "isPacking",
    "Area",
    "created At",
    "Actions",
  ];

  const handleDelete = (orderId) => {
    if (window.confirm("Are you sure you want to delete this Product?")) {
      dispatch(deleteProductItem(orderId))
        .unwrap()
        .then(() => {
          alert(t("ProductDeleted"));
          if (refreshData) refreshData();
        })
        .catch((error) => alert(error || "Failed to delete order."));
    }
  };

  const handleSubmitPricing = async () => {
    const payload = {
      linkOfTracking: `${link}`,
      numberOfTracking: `${numberOfTracking}`,
    };
    // console.log(payload);
    try {
      // Step 1: Extract IDs from products
      const productIds = data
        .filter((product) => product.status === "packed")
        .map((product) => product._id);

      // console.log(productIds)
      // Step 2: Send them to sendProductShipping

      await Promise.all(
        productIds.map((id) => dispatch(sendProductShipping(id)).unwrap())
      );
      // console.log(payload)
      // Step 3: After all requests succeed, execute the basic dispatch
      await dispatch(
        submitItemsToShipment({ cartId: cartID, body: payload })
      ).unwrap();

      setShowModal(false);
      if (refreshData) refreshData();
    } catch (error) {
      alert(error || "Failed to submit request.");
    }
  };

  const handleUpdate = () => {};
  if (loading) {
    return <LoadingSpinner />;
  }
  // console.log(data[0].status)
  return (
    <>
      <Table
        title={t("Packed & UnPacked Products")}
        headers={headers}
        data={data}
        EditingProducts={setEditingProducts}
        renderRow={(product, index) => (
          <DetailsTable
            key={product._id || index}
            index={index + 1}
            details={{
              id: product._id,
              number: index + 1,
              Box: product.ReferenceCode,
              link: product.link,
              info: product.additionalInfo,
              Count: product.count,
              history: product.createdAt,
              weight: product.weight,
              price: product.price || "00.0",
              status: product.status,
              DShippingFees: product.DShippingFees || "00.0",
              category: product.category,
              brand: product.brand,
              area: product.area,
              currency: product.currency,
              name: product.name,
              image:
                product.img || "https://api.markaship.com/uploads/waiting.png",
              isPacking: product.isPacking,
              PackingFees: product.PackingFees,
              size: product.size,
            }}
            isEditing={editingOrder === product._id}
            isPricing={pricingOrder === product._id}
            setEditingOrder={setEditingOrder}
            setPricingOrder={setPricingOrder}
            onDelete={() => handleDelete(product._id)}
            onUpdate={handleUpdate}
            refreshData={refreshData}
          />
        )}
      />

      <div className="flex justify-end mt-4">
        <button
          disabled={
            !data.every((product) => product.status === ("shipped" || "packed"))
          }
          className={`px-4 py-2 rounded font-semibold text-black ${
            data.every((product) => product.status === ("shipped" || "packed"))
              ? "bg-custom-yellow hover:bg-yellow-600"
              : "bg-yellow-200 cursor-not-allowed"
          }`}
          onClick={() => setShowModal(true)}
        >
          {t("Proceed")}
        </button>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-xl">
            <h2 className="mb-4 text-lg font-bold text-black">
              {t("Tracking Link")}
            </h2>
            <input
              type="text"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              className="w-full p-2 mb-4 text-black bg-gray-300 rounded"
            />
            <h2 className="mb-4 text-lg font-bold text-black">
              {t("Number Of Tracking")}
            </h2>
            <input
              type="text"
              value={numberOfTracking}
              onChange={(e) => setNumberOfTracking(e.target.value)}
              className="w-full p-2 mb-4 text-black bg-gray-300 rounded"
            />
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 text-black bg-gray-300 rounded hover:bg-gray-400"
              >
                {t("cancel")}
              </button>
              <button
                disabled={!link || !numberOfTracking}
                onClick={handleSubmitPricing}
                className="px-4 py-2 font-semibold text-black rounded bg-custom-yellow hover:bg-yellow-600 disabled:bg-yellow-200"
              >
                {t("Submit")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PackedProduct;
